var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEntertainment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 19.5C23.5 21.7091 21.7091 23.5 19.5 23.5H12.5C10.2909 23.5 8.5 21.7091 8.5 19.5V13.5635H23.5V19.5ZM18.6201 16.3271C18.3863 16.1226 18.0317 16.1461 17.8271 16.3799L15.6738 18.8398C15.6077 18.915 15.4942 18.9249 15.416 18.8623L14.1016 17.8105C13.859 17.6165 13.5046 17.6559 13.3105 17.8984C13.1165 18.141 13.1559 18.4954 13.3984 18.6895L14.7129 19.7412C15.2613 20.18 16.058 20.1086 16.5205 19.5801L18.6738 17.1201C18.878 16.8863 18.8537 16.5316 18.6201 16.3271ZM11.21 12.4385H8.50098C8.53386 10.2577 10.3114 8.5 12.5 8.5H14.0225L11.21 12.4385ZM19.5 8.5C19.669 8.5 19.8355 8.5109 19.999 8.53125L17.21 12.4385H12.5928L15.4053 8.5H19.5ZM21.1504 8.85645C22.5183 9.47706 23.475 10.8442 23.499 12.4385H18.5928L21.1504 8.85645Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntertainment);
export default __webpack_public_path__ + "static/media/entertainment.bb38c4719d284684dcc0996ccb1b8cba.svg";
export { ForwardRef as ReactComponent };